export default __webpack_public_path__ + "static/media/user.d61c21c6.svg";